"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.azureRegionsRaw = exports.azureRegions = exports.azureRegionSchemaRaw = exports.azureRegionSchema = void 0;
var z = _interopRequireWildcard(require("zod"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
// DO NOT EDIT!
// This file was autogenerated from Configuration manager API
// Endpoint: https://configurationmanager.oriflame.com/hierarchy/environments/config.json
// Run `npm run codegen` to regenerate.

const azureRegionsRaw = exports.azureRegionsRaw = ['CE2', 'EA', 'SCUS', 'WE'];
const azureRegions = exports.azureRegions = ['ce2', 'ea', 'scus', 'we'];
const azureRegionSchemaRaw = exports.azureRegionSchemaRaw = z.enum(azureRegionsRaw);
const azureRegionSchema = exports.azureRegionSchema = z.enum(azureRegions);
//# sourceMappingURL=AzureRegion.js.map